import React from 'react';
import '../Works/Work.css';
import Data from './WorkData'


function Work() {
  return (
    <div className='work-div' id='work'>
        <h3>My Works</h3>

        <div className='sub-div'>
            {
              Data.map((item) => {
                return  <div key={item.id} className="sub-box">
                          <div className='card'>
                            <div className='image'>
                              <img src={item.image}  alt=''/>
                            </div>
                            <div className='text'>
                              <div className='title'>{item.title}</div>
                              <a href={item.link} target='_blank'>Preview</a>
                            </div>
                          </div>
                        </div>  
              })
            }
         
        </div>
    </div>
  )
}

export default Work